import { RedisTreatment } from '../../../../lib/redis/types/RedisTreatment';
import { useTreatmentFilterStateContext } from '../TreatmentFilter/context/TreatmentFilterContext';
import { useSortAndFilterResultsContext } from './SortAndFilterResultsContext';

interface ChildProps {
    filteredTreatments: RedisTreatment[];
    numberOfFiltersApplied: number;
    processing: boolean;
}

interface Props {
    children: (props: ChildProps) => JSX.Element;
}

const SortAndFilterResults = ({ children }: Props) => {
    const { numberOfFiltersApplied } = useTreatmentFilterStateContext();
    const { processedData, processing } = useSortAndFilterResultsContext();

    return children({ filteredTreatments: processedData || [], numberOfFiltersApplied, processing });
};

export default SortAndFilterResults;
